import { render } from "./ListeFactureS.vue?vue&type=template&id=2db5f12f&ts=true"
import script from "./ListeFactureS.vue?vue&type=script&lang=ts"
export * from "./ListeFactureS.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__